import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
} from '@material-ui/core';
import { traerTurnosAfiliadoHCE } from '../../../../actions/hce/hceActions';

const optionsfecha = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const TabTurnos = ({ hce, dataAfiliado }) => {

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(traerTurnosAfiliadoHCE(hce.idAfiliado, hce.idAfiliadoExterno));
  }, []);
  const { turnos } = useSelector((state) => state.hce);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left">Fecha</TableCell>
            <TableCell align="left">Hora</TableCell>
            <TableCell align="left">Dr./Dra.</TableCell>
            <TableCell align="left">Centro Médico</TableCell>
            <TableCell align="left">Especialidad</TableCell>
            <TableCell align="left">Estado</TableCell>
            <TableCell align="left">Modalidad</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {turnos.length > 0 ? (
            turnos.map((item) => (
              <TableRow key={item.idAgenda}>
                <TableCell align="left">
                  {new Date(item.fecha).toLocaleString('es', optionsfecha)}
                </TableCell>
                <TableCell align="left">{item.hora}</TableCell>
                <TableCell align="left">
                  {item.descripcionEfector}
                </TableCell>
                <TableCell align="left">
                  {item.descripcionCentroMedico}
                </TableCell>
                <TableCell align="left">
                  {item.descripcionEspecialidad}
                </TableCell>
                <TableCell align="left">
                  {item.confirmado ? 'PRESENTE' : 'AUSENTE'}
                </TableCell>
                <TableCell align="left">
                  {item.idTipoTurnoSol === 1 ? 'Presencial' : 'Virtual'}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow style={{ height: 50 }}>
              <TableCell colSpan={8} style={{ textAlign: '-webkit-center' }}>
                {' '}
                Sin Registros
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
